export const FIRST_PARTY_QUICKAPP_UTM_PARAMS = {
    utm_source: 'zillow',
    utm_campaign: 'zhl_dashboard_quickapp',
    utm_medium: 'dashboard',
};

export const FIRST_PARTY_FULLAPP_UTM_PARAMS = {
    utm_source: 'zillow',
    utm_campaign: 'zhl_dashboard_fullapp',
    utm_medium: 'dashboard',
};
